import React from 'react';
import PropTypes from 'prop-types';
import { getNetworkLogoUrl } from 'helpers/ContentHelper';
import { formatAiredDate } from 'helpers/VideoHelper';
import Style from './Meta.module.scss';

const Meta = ({ item, episode = {} }) => {
  const { network, tuneIn, retired } = item;
  const { originalAirDate } = episode;
  const airDate = formatAiredDate(originalAirDate);
  const hasNetworkLogo = !!window.ExternalConfig.networkLogo;
  const networkLogoUrl = hasNetworkLogo ? getNetworkLogoUrl(network) : null;
  const { seriesDetail_retiredShowTuneInLabel: retiredTuneInLabel } = window.Language;
  let tuneInText = retired ? tuneIn || retiredTuneInLabel : tuneIn;
  if (!tuneInText) tuneInText = airDate.replace(/-/g, '/');
  return (
    <span className={Style.meta}>
      <img src={networkLogoUrl} alt={network} />
      {tuneInText && <span>{tuneInText}</span>}
    </span>
  );
};

Meta.propTypes = {
  item: PropTypes.shape({
    network: PropTypes.string,
    tuneIn: PropTypes.string,
  }).isRequired,
  episode: PropTypes.shape({}),
};

export default Meta;
